function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _class2, _class3, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable no-console */

/* eslint-disable max-len */

/* eslint no-mixed-spaces-and-tabs: "off" */
import { Component, register, bind, emitEvent, el, reactive, watch, dataParam } from 'ovee.js';
import gsap from 'gsap';
import axios from 'axios';
import { FormValidator } from '../tools/form-validator/form-validator';
import { phone, email, required } from '../tools/form-validator/rules';

var filter = function filter(list, selector) {
  list = _toConsumableArray(list);
  return list.filter(function (item) {
    return item.matches(selector);
  });
};

var each = function each(list) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (!list) {
    return;
  }

  list.forEach(function (item) {
    return callback(item);
  });
};

var is = function is(element, selector) {
  if (selector.nodeType) {
    return element === selector;
  }

  var elements = typeof selector === 'string' ? document.querySelectorAll(selector) : selector;
  var elementsLength = elements.length;

  while (elementsLength--) {
    if (elements[elementsLength] === element) {
      return true;
    }
  }

  return false;
};

var DEFAULT_FORMS_VERSION = 2;

var _class = (_dec = register('form-base'), _dec2 = el('.form__ajax-message', {
  list: true
}), _dec3 = el('[data-form-step-label]', {
  list: true
}), _dec4 = dataParam('success'), _dec5 = reactive(), _dec6 = bind('blur change', 'input, select, textarea'), _dec7 = bind('change', 'select'), _dec8 = bind('change', 'input[type=radio]'), _dec9 = bind('click', '.custom-checkbox'), _dec10 = bind('click', '[data-form-next]'), _dec11 = bind('click', '[data-form-previous]'), _dec12 = bind('error'), _dec13 = bind('submit'), _dec14 = bind('modal-close', window), _dec15 = bind('modal-close', window), _dec16 = watch('currentStep'), _dec(_class2 = (_class3 = (_temp = /*#__PURE__*/function (_Component) {
  _inherits(_class3, _Component);

  var _super = _createSuper(_class3);

  function _class3() {
    var _this;

    _classCallCheck(this, _class3);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_assertThisInitialized(_this), "ajaxMessage", _descriptor, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "version", DEFAULT_FORMS_VERSION);

    _initializerDefineProperty(_assertThisInitialized(_this), "stepsLabels", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "successMessage", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "currentStep", _descriptor4, _assertThisInitialized(_this));

    return _this;
  }

  _createClass(_class3, [{
    key: "init",
    value: function init() {
      var _ref, _this$$element$datase;

      this.version = (_ref = (_this$$element$datase = this.$element.dataset.formVersion) !== null && _this$$element$datase !== void 0 ? _this$$element$datase : this.$app.getConfig().formsVersion) !== null && _ref !== void 0 ? _ref : DEFAULT_FORMS_VERSION;
      this.version = parseInt(this.version, 10);
      this.successElement = this.successMessage ? document.querySelector(this.successMessage) : null;
      this.errorContainer = this.$element.querySelector('.base-form__errors');
      this.errorList = {
        base: 'Please fill out the highlighted information.',
        email: 'Please enter a valid email address.',
        consent: 'Please agree to the terms and conditions.',
        phone: 'Please enter a valid phone number.'
      };
      this.errorSummary = {
        base: [],
        email: [],
        consent: [],
        phone: []
      };
      this.formValidator = new FormValidator({
        element: this.$element,
        errorElementClass: 'base-form__error',
        rules: {
          required: required,
          email: email,
          phone: phone
        }
      });
      this.initSteps();
    }
  }, {
    key: "inputBlurHandler",
    value: function inputBlurHandler(_ref2) {
      var target = _ref2.target;
      var validCheck = this.formValidator.isFieldValid(target);
      this.updateErrorSummary(target, validCheck);
    }
  }, {
    key: "selectChangeHandler",
    value: function selectChangeHandler(_ref3) {
      var target = _ref3.target;
      var parentNode = target.closest('.custom-select');

      if (parentNode.classList.contains('has-error')) {
        parentNode.classList.remove('has-error');
      }
    }
  }, {
    key: "radioChangeHandler",
    value: function radioChangeHandler(_ref4) {
      var target = _ref4.target;
      var parentNode = target.closest('.custom-radio');

      if (parentNode.classList.contains('has-error')) {
        parentNode.classList.remove('has-error');
      }
    }
  }, {
    key: "customCheckboxClickHandler",
    value: function customCheckboxClickHandler(_ref5) {
      var target = _ref5.target;
      var checkboxInput = target.querySelector('input[type="checkbox"]');

      if (checkboxInput) {
        checkboxInput.classList.remove('has-error');
      }
    }
  }, {
    key: "nextStepHandler",
    value: function nextStepHandler(e) {
      e.preventDefault();
      this.nextStep();
    }
  }, {
    key: "previousStepHandler",
    value: function previousStepHandler(e) {
      e.preventDefault();
      this.previousStep();
    }
  }, {
    key: "scrollToFirstError",
    value: function scrollToFirstError() {
      var target = this.$element.querySelector('.base-form__errors');
      var firstErr = this.$element.querySelector('.base-form__input.has-error');

      if (target && target.children.length) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      } else if (firstErr) {
        firstErr.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }
  }, {
    key: "submitHandler",
    value: function () {
      var _submitHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                if (this.isLastStep()) {
                  this.hideAjaxMessage();
                  this.removeErrors();
                  this.submit().then(function () {
                    if (window.grecaptcha) {
                      window.grecaptcha.reset();
                    }
                  });
                } else {
                  this.nextStep();
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submitHandler(_x) {
        return _submitHandler.apply(this, arguments);
      }

      return submitHandler;
    }()
  }, {
    key: "hideAjaxMessage",
    value: function hideAjaxMessage() {
      each(this.ajaxMessage, function (msg) {
        return msg.style.display = 'none';
      });
    }
  }, {
    key: "removeErrors",
    value: function removeErrors() {
      var inputs = this.$element.querySelectorAll('input, select, textarea, select, .custom-select, .custom-radio');
      each(inputs, function (input) {
        input.classList.remove('has-error');
        emitEvent(input, 'blur');
      });
    } // @bind('modal-open', window)

  }, {
    key: "resetInputStatuses",
    value: function resetInputStatuses() {
      var inputs = this.$element.querySelectorAll('input, select, textarea');
      each(inputs, function (input) {
        input.classList.remove('has-error', 'is-valid');
      });
    }
  }, {
    key: "showErrorMsg",
    value: function showErrorMsg() {
      var errorMsg = filter(this.ajaxMessage, '.has-error');

      if (errorMsg.length > 0) {
        gsap.to(errorMsg, {
          opacity: 1,
          duration: 0.4,
          onStart: function onStart() {
            each(errorMsg, function (msg) {
              return msg.style.display = 'block';
            });
          }
        });
      }
    }
  }, {
    key: "showSuccessMsg",
    value: function showSuccessMsg() {
      var successMsg = filter(this.ajaxMessage, '.is-success');

      if (successMsg.length > 0) {
        gsap.to(successMsg, {
          opacity: 1,
          duration: 0.4,
          onStart: function onStart() {
            each(successMsg, function (msg) {
              return msg.style.display = 'block';
            });
          }
        });
      }
    }
  }, {
    key: "endpointUrl",
    value: function endpointUrl() {
      if (this.version === 1) {
        return "".concat(ajaxurl, "?action=form_").concat(this.action);
      }

      var baseUrl = document.querySelector('link[rel="https://api.w.org/"]').href;
      return "".concat(baseUrl, "owd-forms/v2/forms/").concat(this.action, "/submit");
    }
  }, {
    key: "validationEndpointUrl",
    value: function validationEndpointUrl() {
      if (this.version === 1) {
        return "".concat(ajaxurl, "?action=validate_form_").concat(this.action);
      }

      var baseUrl = document.querySelector('link[rel="https://api.w.org/"]').href;

      if (this.stepsEnabled) {
        return "".concat(baseUrl, "owd-forms/v2/forms/").concat(this.action, "/step/").concat(this.currentStep + 1, "/validate");
      }

      return "".concat(baseUrl, "owd-forms/v2/forms/").concat(this.action, "/validate");
    }
  }, {
    key: "endpointHeaders",
    value: function endpointHeaders() {
      var _document$documentEle, _document$documentEle2;

      return {
        'x-pll-lang': (_document$documentEle = document.documentElement.lang) === null || _document$documentEle === void 0 ? void 0 : (_document$documentEle2 = _document$documentEle.split('-')) === null || _document$documentEle2 === void 0 ? void 0 : _document$documentEle2[0]
      };
    }
  }, {
    key: "filterData",
    value: function filterData(data) {
      return data;
    }
  }, {
    key: "getErrorsFromResponse",
    value: function getErrorsFromResponse(response) {
      var _response$data, _response$data3, _response$data3$data;

      if (this.version === 1) {
        return (response === null || response === void 0 ? void 0 : response.errors) || {};
      }

      if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.errors) {
        var _response$data2;

        return response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.errors;
      } // FIXME: remove nested data object


      return (response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$data = _response$data3.data) === null || _response$data3$data === void 0 ? void 0 : _response$data3$data.errors) || {};
    }
  }, {
    key: "checkResponse",
    value: function checkResponse(response, status) {
      if (this.version === 1) {
        return ['200', '201', 200, 201].includes(status) && !!response.result;
      }

      if (status === 403 && (response === null || response === void 0 ? void 0 : response.code) === 'rest_cookie_invalid_nonce') {
        document.location.reload();
      }

      return [200, 201, '200', '201'].includes(status);
    }
  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var ajaxParams;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ajaxParams = {
                  url: this.validationEndpointUrl(),
                  method: 'POST',
                  headers: this.endpointHeaders(),
                  data: new URLSearchParams(new FormData(this.$element)).toString() // URLSearchParams -> IE: Not supported

                };

                if (this.isMultiPart) {
                  ajaxParams.data = new FormData(this.$element);
                }

                ajaxParams.data = this.filterData(ajaxParams.data);
                _context2.prev = 3;
                _context2.next = 6;
                return axios(ajaxParams);

              case 6:
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](3);
                this.handleErrors(_context2.t0);
                return _context2.abrupt("return", false);

              case 12:
                return _context2.abrupt("return", true);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 8]]);
      }));

      function validate() {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: "submit",
    value: function submit() {
      var _this2 = this;

      var formData = new FormData(this.$element);

      if (formData.has('interest')) {
        var interest = ''; // eslint-disable-next-line no-restricted-syntax

        var _iterator = _createForOfIteratorHelper(formData),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                key = _step$value[0],
                value = _step$value[1];

            if (key === 'interest') {
              interest += "".concat(value, ", ");
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (interest) interest = interest.slice(0, -2);
        formData["delete"]('interest');
        formData.append('interest', interest);
      }

      if (formData.has('space')) {
        var space = ''; // eslint-disable-next-line no-restricted-syntax

        var _iterator2 = _createForOfIteratorHelper(formData),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
                _key2 = _step2$value[0],
                _value = _step2$value[1];

            if (_key2 === 'space') {
              space += "".concat(_value, ", ");
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        if (space) space = space.slice(0, -2);
        formData["delete"]('space');
        formData.append('space', space);
      }

      if (formData.has('hire')) {
        var hire = ''; // eslint-disable-next-line no-restricted-syntax

        var _iterator3 = _createForOfIteratorHelper(formData),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _step3$value = _slicedToArray(_step3.value, 2),
                _key3 = _step3$value[0],
                _value2 = _step3$value[1];

            if (_key3 === 'hire') {
              hire += "".concat(_value2, ", ");
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }

        if (hire) hire = hire.slice(0, -2);
        formData["delete"]('hire');
        formData.append('hire', hire);
      }

      var ajaxParams = {
        url: this.endpointUrl(),
        method: 'POST',
        headers: this.endpointHeaders(),
        data: new URLSearchParams(formData).toString() // URLSearchParams -> IE: Not supported

      };

      if (this.isMultiPart) {
        ajaxParams.data = new FormData(this.$element);
      }

      ajaxParams.data = this.filterData(ajaxParams.data);
      /* eslint no-undef: "off" */

      if (window.ga !== undefined) {
        try {
          ga('send', 'event', 'form', 'submit', this.action);
        } catch (e) {
          console.error(e);
        }
      }

      return axios(ajaxParams).then(function (response) {
        return [response.data, response.status];
      }).then(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            response = _ref7[0],
            status = _ref7[1];

        if (_this2.checkResponse(response, status)) {
          setTimeout(function () {
            _this2.resetForm();

            _this2.resetSummary();
          }, 1000);

          _this2.handleSuccessElement();

          emitEvent(_this2.$element, 'success', response);
          return true;
        } // eslint-disable-next-line prefer-promise-reject-errors


        return Promise.reject({
          response: response,
          status: status
        });
      })["catch"](function (e) {
        _this2.handleErrors(e);
      });
    }
  }, {
    key: "handleSuccessElement",
    value: function handleSuccessElement() {
      var _this3 = this;

      if (this.successElement) {
        if (this.action === 'newsletter' || this.action === 'download') {
          var newsletterElements = document.querySelectorAll('.newsletter__title, [data-form-base=newsletter], [data-form-base=download]');
          gsap.to(newsletterElements, {
            opacity: 0,
            duration: 0.4,
            onComplete: function onComplete() {
              _this3.successElement.classList.add('is-visible');
            }
          });
        } else {
          this.successElement.addEventListener('transitionend', function () {
            if (!_this3.successElement.previousElementSibling) return;
            _this3.successElement.previousElementSibling.style.display = 'none';
          }, {
            once: true
          });
          this.successElement.classList.add('is-visible');
        }

        var modal = this.$element.closest('.modal');

        if (modal) {
          modal.classList.add('is-locked');
        }
      }
    }
  }, {
    key: "clearSuccessElement",
    value: function clearSuccessElement() {
      var _this4 = this;

      if (this.successElement && this.successElement.classList.contains('is-visible')) {
        setTimeout(function () {
          _this4.successElement.classList.remove('is-visible');

          var modal = _this4.$element.closest('.modal');

          if (modal) {
            modal.classList.remove('is-locked');
            modal.scrollTop = 0;
          }

          _this4.resetForm();

          _this4.resetSummary();
        }, 1000);

        if (this.action === 'newsletter' || this.action === 'download') {
          var newsletterElements = document.querySelectorAll('.newsletter__desc, .newsletter__title, [data-form-base=newsletter], [data-form-base=download]');
          gsap.to(newsletterElements, {
            opacity: 1,
            duration: 0.4,
            onComplete: function onComplete() {
              _this4.successElement.classList.add('is-visible');
            }
          });
        }
      }
    }
  }, {
    key: "addToSummmary",
    value: function addToSummmary(name, group) {
      if (!this.errorSummary[group].includes(name)) {
        this.errorSummary[group].push(name);
      }
    }
  }, {
    key: "removeFromSummary",
    value: function removeFromSummary(name) {
      var _this5 = this;

      var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!group) {
        Object.entries(this.errorSummary).forEach(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
              key = _ref9[0],
              value = _ref9[1];

          _this5.errorSummary[key] = value.filter(function (item) {
            return item !== name;
          });
        });
      } else {
        this.errorSummary[group] = this.errorSummary[group].filter(function (item) {
          return item !== name;
        });
      }
    }
  }, {
    key: "resetSummary",
    value: function resetSummary() {
      var _this6 = this;

      Object.keys(this.errorSummary).forEach(function (key) {
        _this6.errorSummary[key] = [];
      });
      this.errorContainer.innerHTML = '';
    }
  }, {
    key: "updateErrorSummary",
    value: function updateErrorSummary(target, response) {
      var _this7 = this;

      var fieldName = target.name;
      this.errorContainer.innerHTML = '';

      if (response) {
        var fieldRule = response.rule;

        if (fieldName === 'email') {
          if (fieldRule === 'email') {
            this.addToSummmary(fieldName, 'email');
            this.removeFromSummary(fieldName, 'base');
          } else {
            this.addToSummmary(fieldName, 'base');
            this.removeFromSummary(fieldName, 'email');
          }
        } else if (fieldName === 'phone') {
          if (fieldRule === 'phone') {
            this.addToSummmary(fieldName, 'phone');
            this.removeFromSummary(fieldName, 'base');
          } else {
            this.addToSummmary(fieldName, 'base');
            this.removeFromSummary(fieldName, 'phone');
          }
        } else if (fieldName === 'consent') {
          this.addToSummmary(fieldName, 'consent');
        } else {
          this.addToSummmary(fieldName, 'base');
        }
      } else {
        this.removeFromSummary(fieldName);
      }

      Object.keys(this.errorSummary).forEach(function (type) {
        if (_this7.errorSummary[type].length) {
          var spanEl = document.createElement('span');
          spanEl.innerText = _this7.errorList[type];
          spanEl.className = 'base-form__error';

          _this7.errorContainer.appendChild(spanEl);
        }
      });
    }
  }, {
    key: "handleErrors",
    value: function handleErrors(e) {
      var _this8 = this;

      this.showErrorMsg();
      Object.keys(this.getErrorsFromResponse(e.response)).forEach(function (name) {
        var inputs = _this8.$element.querySelectorAll("input[name=\"".concat(name, "\"],input[name^=\"").concat(name, "[\"],textarea[name=\"").concat(name, "\"]"));

        var select = _this8.$element.querySelectorAll("select[name=\"".concat(name, "\"]"));

        var radio = _this8.$element.querySelectorAll("input[type=radio][name=\"".concat(name, "\"]"));

        var errorMessage = _this8.getErrorsFromResponse(e.response)[name];

        each(inputs, function (input) {
          var mess = _this8.getErrorsFromResponse(e.response)[name];

          var errorElement = input.parentElement.querySelector('.base-form__error');
          if (!errorElement || !mess) return;
          input.classList.add('has-error');
          errorElement.innerText = mess;
          emitEvent(input, 'error');
        });
        each(radio, function (customRadio) {
          if (!customRadio) return;
          var radioParent = customRadio.closest('.custom-radio');

          if (radioParent) {
            var errorElement = radioParent.querySelector('.base-form__error');
            radioParent.classList.add('has-error');

            if (errorElement) {
              errorElement.innerText = errorMessage;
            }
          }

          emitEvent(customRadio, 'error');
        });
        each(select, function (customSelect) {
          if (!customSelect) return;
          var selectParent = customSelect.closest('.custom-select');

          if (selectParent) {
            var errorElement = selectParent.nextElementSibling.querySelector('.base-form__error');
            selectParent.classList.add('has-error');

            if (errorElement) {
              errorElement.innerText = errorMessage;
            }
          }

          emitEvent(customSelect, 'error');
        }); // FIXME: this condition is not working every time

        if (_this8.getErrorsFromResponse(e.response)['g-recaptcha-response']) {
          var ReCaptcha = _this8.$element.querySelector('.recaptcha');

          var errorElement = ReCaptcha.querySelector('span.base-form__error');
          if (!errorElement || !ReCaptcha) return;
          ReCaptcha.classList.add('has-error');
          errorElement.innerText = _this8.getErrorsFromResponse(e.response)['g-recaptcha-response'];
        }
      });
      emitEvent(this.$element, 'error');
      this.errorStep();
    }
  }, {
    key: "enableLoading",
    value: function enableLoading() {
      this.$element.classList.add('loading');
    }
  }, {
    key: "disableLoading",
    value: function disableLoading() {
      this.$element.classList.remove('loading');
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      if (this.$element.dataset.formNoReset === undefined) {
        var inputs = this.$element.querySelectorAll('input[type=file],input[type=text],input[type=tel],input[type=number],select,input[type=email],textarea');
        var checkboxes = this.$element.querySelectorAll('input[type=checkbox]');
        each(inputs, function (input) {
          input.classList.remove('has-error');
          input.value = '';
          emitEvent(input, 'change');
        });
        each(checkboxes, function (checkbox) {
          checkbox.classList.remove('has-error');
          checkbox.checked = false;
          emitEvent(checkbox, 'change');
        });
        this.resetInputStatuses();
        this.$element.reset();
      }
    }
  }, {
    key: "hideButtons",
    value: function hideButtons() {
      if (this.stepsEnabled && this.buttonPrev && this.buttonNext) {
        each([this.buttonPrev, this.buttonNext], function (button) {
          button.classList.remove('visually-hidden');
        });
        this.buttonSubmit.classList.add('visually-hidden');

        if (this.isFirstStep()) {
          this.buttonPrev.classList.add('visually-hidden');
        } else if (this.isLastStep()) {
          this.buttonNext.classList.add('visually-hidden');
          this.buttonSubmit.classList.remove('visually-hidden');
        }
      }
    }
  }, {
    key: "initSteps",
    value: function initSteps() {
      if (this.$element.querySelectorAll('.form-part').length) {
        this.$steps = this.$element.querySelectorAll('.form-part:not(.success)');
        this.$defaultStep = this.$element.querySelectorAll('.form-part.default');
        this.$successStep = this.$element.querySelectorAll('.form-part.success');
        this.buttonPrev = this.$element.querySelector('[data-form-previous]');
        this.buttonNext = this.$element.querySelector('[data-form-next]');
        this.buttonSubmit = this.$element.querySelector('[data-form-submit]');
        this.stepsCount = this.$steps.length;
        this.stepsEnabled = true;
      } else {
        this.stepsEnabled = false;
      }

      this.hideButtons();
      this.animateStepsLabels();
    }
  }, {
    key: "resetFormSteps",
    value: function resetFormSteps(e) {
      if (e.detail === this.action && this.stepsEnabled && this.isSuccessStep) {
        this.currentStep = 0;

        if (e.detail === 'account') {
          this.hideButtons();
          this.animateStepsLabels();
        }

        this.hideVisibleSteps();
        this.removeErrors();
        this.$successStep[0].classList.remove('is-visible');
        this.$defaultStep[0].classList.add('is-visible');
      }

      this.clearSuccessElement();
    }
  }, {
    key: "hideVisibleSteps",
    value: function hideVisibleSteps() {
      var visibleSteps = filter(this.$steps, '.is-visible');
      each(visibleSteps, function (step) {
        step.classList.remove('is-visible');
      });
    }
  }, {
    key: "defaultStep",
    value: function defaultStep() {
      var _this9 = this;

      if (this.stepsEnabled) {
        this.hideVisibleSteps();
        each(this.$successStep, function (step) {
          step.classList.remove('is-visible');
        });
        each(this.$defaultStep, function (step) {
          step.classList.add('is-visible');
        });
        setTimeout(function () {
          var firstInput = _this9.$defaultStep.querySelector('input');

          emitEvent(firstInput, 'focus');
        }, 100);
      }
    }
  }, {
    key: "successStep",
    value: function successStep() {
      if (this.stepsEnabled) {
        this.hideVisibleSteps();
        each(this.$successStep, function (step) {
          step.classList.add('is-visible');
        });
      }
    }
  }, {
    key: "errorStep",
    value: function errorStep() {
      if (this.stepsEnabled) {
        var _this$stepsLabels;

        var errorStepIndex = Array.from(this.$steps).findIndex(function (step) {
          return !!step.querySelector('.has-error');
        });
        var step = this.$steps[errorStepIndex];
        (_this$stepsLabels = this.stepsLabels) === null || _this$stepsLabels === void 0 ? void 0 : _this$stepsLabels.forEach(function (stepLabel, i) {
          if (i >= errorStepIndex) {
            stepLabel.classList.remove('is-completed');
          }
        });

        if (!is(this.$steps.item(this.currentStep), step)) {
          var _step$querySelector;

          this.currentStep = errorStepIndex;
          this.hideButtons();
          this.hideVisibleSteps();
          step.classList.add('is-visible');
          (_step$querySelector = step.querySelector('input.has-error')) === null || _step$querySelector === void 0 ? void 0 : _step$querySelector.focus();
        }
      }
    }
  }, {
    key: "isLastStep",
    value: function isLastStep() {
      if (this.stepsEnabled) {
        return this.currentStep + 1 >= this.stepsCount;
      }

      return true;
    }
  }, {
    key: "isFirstStep",
    value: function isFirstStep() {
      if (this.stepsEnabled) {
        return this.currentStep - 1 < 0;
      }

      return true;
    }
  }, {
    key: "isSuccessStep",
    value: function isSuccessStep() {
      if (this.stepsEnabled) {
        return this.$successStep[0].classList.contains('is-visible');
      }

      return false;
    }
  }, {
    key: "nextStep",
    value: function () {
      var _nextStep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this10 = this;

        var _currentStep$classLis, _currentStep$classLis2, _currentStep$querySel, inputs, isValid, currentStep;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.stepsEnabled && !this.isLastStep())) {
                  _context3.next = 14;
                  break;
                }

                inputs = this.$steps.item(this.currentStep).querySelectorAll('input, textarea');
                each(inputs, function (input) {
                  _this10.formValidator.isFieldValid(input);
                });
                _context3.next = 5;
                return this.validate();

              case 5:
                isValid = _context3.sent;

                if (isValid) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return");

              case 8:
                this.currentStep++;
                this.hideVisibleSteps();
                this.hideButtons();
                currentStep = this.$steps.item(this.currentStep);
                /* eslint no-unused-expressions: "off" */

                currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$classLis = currentStep.classList) === null || _currentStep$classLis === void 0 ? void 0 : (_currentStep$classLis2 = _currentStep$classLis.add) === null || _currentStep$classLis2 === void 0 ? void 0 : _currentStep$classLis2.call(_currentStep$classLis, 'is-visible');
                emitEvent(currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$querySel = currentStep.querySelector) === null || _currentStep$querySel === void 0 ? void 0 : _currentStep$querySel.call(currentStep, 'input'), 'focus');

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function nextStep() {
        return _nextStep.apply(this, arguments);
      }

      return nextStep;
    }()
  }, {
    key: "previousStep",
    value: function previousStep() {
      if (this.stepsEnabled && !this.isFirstStep()) {
        var _currentStep$classLis3, _currentStep$classLis4, _currentStep$querySel2;

        this.currentStep--;
        this.hideVisibleSteps();
        this.hideButtons();
        var currentStep = this.$steps.item(this.currentStep);
        /* eslint no-unused-expressions: "off" */

        currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$classLis3 = currentStep.classList) === null || _currentStep$classLis3 === void 0 ? void 0 : (_currentStep$classLis4 = _currentStep$classLis3.add) === null || _currentStep$classLis4 === void 0 ? void 0 : _currentStep$classLis4.call(_currentStep$classLis3, 'is-visible');
        emitEvent(currentStep === null || currentStep === void 0 ? void 0 : (_currentStep$querySel2 = currentStep.querySelector) === null || _currentStep$querySel2 === void 0 ? void 0 : _currentStep$querySel2.call(currentStep, 'input'), 'focus');
      }
    }
  }, {
    key: "animateStepsLabels",
    value: function animateStepsLabels(currentStep, prevStep) {
      if (!this.stepsEnabled || !this.stepsLabels) {
        return;
      }

      each(this.stepsLabels, function (label) {
        if (label.classList.contains('is-active')) {
          label.classList.remove('is-active');
        }
      });

      if (this.currentStep === 0) {
        each(this.stepsLabels, function (label) {
          if (label.classList.contains('is-completed')) {
            label.classList.remove('is-completed');
          }
        });
      }

      if (this.stepsLabels[this.currentStep]) {
        var _this$stepsLabels2;

        (_this$stepsLabels2 = this.stepsLabels) === null || _this$stepsLabels2 === void 0 ? void 0 : _this$stepsLabels2[this.currentStep].classList.add('is-active');
      }

      if (currentStep > prevStep) {
        var _this$stepsLabels3;

        (_this$stepsLabels3 = this.stepsLabels) === null || _this$stepsLabels3 === void 0 ? void 0 : _this$stepsLabels3[prevStep].classList.add('is-completed');
      } else if (currentStep < prevStep) {
        var _this$stepsLabels4;

        (_this$stepsLabels4 = this.stepsLabels) === null || _this$stepsLabels4 === void 0 ? void 0 : _this$stepsLabels4[currentStep].classList.remove('is-completed');
      }
    }
  }, {
    key: "isMultiPart",
    get: function get() {
      return this.$element.getAttribute('enctype') === 'multipart/form-data';
    }
  }, {
    key: "action",
    get: function get() {
      return this.$element.dataset.formBase;
    }
  }]);

  return _class3;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class3.prototype, "ajaxMessage", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class3.prototype, "stepsLabels", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class3.prototype, "successMessage", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class3.prototype, "currentStep", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _applyDecoratedDescriptor(_class3.prototype, "inputBlurHandler", [_dec6], Object.getOwnPropertyDescriptor(_class3.prototype, "inputBlurHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "selectChangeHandler", [_dec7], Object.getOwnPropertyDescriptor(_class3.prototype, "selectChangeHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "radioChangeHandler", [_dec8], Object.getOwnPropertyDescriptor(_class3.prototype, "radioChangeHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "customCheckboxClickHandler", [_dec9], Object.getOwnPropertyDescriptor(_class3.prototype, "customCheckboxClickHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "nextStepHandler", [_dec10], Object.getOwnPropertyDescriptor(_class3.prototype, "nextStepHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "previousStepHandler", [_dec11], Object.getOwnPropertyDescriptor(_class3.prototype, "previousStepHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "scrollToFirstError", [_dec12], Object.getOwnPropertyDescriptor(_class3.prototype, "scrollToFirstError"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "submitHandler", [_dec13], Object.getOwnPropertyDescriptor(_class3.prototype, "submitHandler"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "hideAjaxMessage", [_dec14], Object.getOwnPropertyDescriptor(_class3.prototype, "hideAjaxMessage"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "resetFormSteps", [_dec15], Object.getOwnPropertyDescriptor(_class3.prototype, "resetFormSteps"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "animateStepsLabels", [_dec16], Object.getOwnPropertyDescriptor(_class3.prototype, "animateStepsLabels"), _class3.prototype)), _class3)) || _class2);

export { _class as default };